import { ProductVariantData } from 'lib/bigcommerce/types';
import React from 'react';
import { numberToCurrency } from 'utils/currency';

type ProductPriceProps = {
  variant: ProductVariantData;
  currency: string;
};

const ProductPrice: React.FC<ProductPriceProps> = (props) => {
  const { variant, currency } = props;

  const activePrice = variant.salePrice || variant.basePrice;
  return (
    <>
      <span className="text-lg font-medium">{numberToCurrency(activePrice, currency)}</span>
      {variant.salePrice && variant.salePrice != variant.basePrice && (
        <>
          <span className="text-lg font-normal text-sf-blue-500 line-through">
            {numberToCurrency(variant.basePrice, currency)}
          </span>
        </>
      )}
    </>
  );
};
export default ProductPrice;
